import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-left",
  "use": "icon-arrow-left-usage",
  "viewBox": "0 0 32 22",
  "content": "<symbol viewBox=\"0 0 32 22\" id=\"icon-arrow-left\"><path d=\"M31.2688 9.16687V12.8335H7.7502L13.6948 18.7782L11.1021 21.3709L0.731201 11L11.1021 0.629089L13.6948 3.22181L7.74977 9.16687L31.2688 9.16687Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol